import MetaFootballModel from "../../Football/Models/Pagination/MetaFootballModel";
import ListContentModel from "./ListContentModel";
import ListContentResponseModel from "./ListContentResponseModel";

export default class ListContentRemapper {
  public remapListContent = (data: any): ListContentResponseModel => {
    const response = new ListContentResponseModel();

    response.meta = this.remapMeta(data.meta);
    response.data = data.data.map((item: any) => {
      const model = new ListContentModel();

      model.entityId = item.entity_id;
      model.entityType = item.entity_type;

      return model;
    });

    return response;
  };

  private remapMeta = (meta: any) => {
    const model = new MetaFootballModel();

    model.pagination.currentPage = meta.pagination.current_page;
    model.pagination.itemsPerPage = meta.pagination.items_per_page;
    model.pagination.totalItems = meta.pagination.total_items;
    model.pagination.numberOfPages = meta.pagination.number_of_pages;

    return model;
  };
}
